/**
 * Check if DEBUG=True cookie exists.
 * Returns true only if the cookie is explicitly set to "True".
 */
export const hasDebugCookie = (): boolean => {
  if (typeof document === 'undefined') return false;
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'DEBUG' && value === 'True') {
      return true;
    }
  }
  return false;
};
